<script>
import baseMixin from '@/mixins/baseMixin'
import { sample } from 'lodash'

export default {
  name: 'BaseCheckboxListSkeleton',
  mixins: [baseMixin],
  props: {
    quantity: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    randomWidth() {
      return sample(['200', '250', '180', '160', '120', '140'])
    },
  },
}
</script>

<template>
  <article>
    <v-checkbox
      v-for="i of quantity"
      :key="`base-checkbox-list-skeleton-${i}`"
      disabled
      class="mb-0 mt-2 base-checkbox-list-skeleton"
      hide-details
    >
      <template v-slot:label>
        <v-skeleton-loader
          :style="`width: ${randomWidth()}px`"
          type="text"
        ></v-skeleton-loader>
      </template>
    </v-checkbox>
  </article>
</template>
